import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const SUBSCRIPTION_KEY = process.env.REACT_APP_SUBSCRIPTION_KEY;

type RequestOptions = {
  path: string;
  method?: string;
  data?: any;
  token?: string;
};

const request = ({ path, method = "GET", data, token }: RequestOptions) => {
  const url = API_URL + path;
  const headers = {
    ...(SUBSCRIPTION_KEY && { "ocp-apim-subscription-key": SUBSCRIPTION_KEY }),
    ...(token && { authorization: `Bearer ${token}` }),
  };

  return axios({ method, headers, data, url });
};

export { request };
